const sandboxMode =
  window.location.host.startsWith("localhost") ||
  window.location.host == "airsequel.fly.dev"

const allSubscriptionIds = {
  live : {
    enterpriseCloud : {
      yearly: 812270,
      halfYearly: 812268,
      monthly: 812264,
    },
    pro : {
      yearly: 812269,
      halfYearly: 812267,
      monthly: 812263,
    },
  },
  test : {
    enterpriseCloud : {
      yearly: 45869,
      halfYearly: 45868,
      monthly: 45795,
    },
    pro : {
      yearly: 50317,
      halfYearly: 50316,
      monthly: 50315,
    },
  },
}

const prices = {
  yearly: null,
  halfYearly: null,
  monthly: null,
}

customElements.define("checkout-elem",
  class extends HTMLElement {
    constructor() {
      super()
      this.Paddle = null
    }

    openForProduct (productId) {
      this.Paddle.Checkout.open({
        email: this.getAttribute("email"),
        method: "inline",
        product: productId,
        allowQuantity: false,
        disableLogout: true,
        frameTarget: "checkout-container",
        frameInitialHeight: 500,
        frameStyle: `
          width: 100%;
          min-width: 312px;
          min-height: 100%;
          background-color: white;
          border: 1px solid gray;
          border-radius: 0.375rem;
        `,
        customData: {
          airsequel_instance: window.location.host,
          airsequel_team_name: window.location.pathname
            .replace(/^\/teams\/([^\/]+)\/billing/, "$1"),
        },
      })
    }

    connectedCallback() {
      this.attachShadow({ mode: "open" })

      const edition = this.getAttribute("edition")

      if (!edition) {
        throw new Error("Attribute 'edition' is required")
      }

      this.subscriptionIds = sandboxMode
        ? allSubscriptionIds.test[edition]
        : allSubscriptionIds.live[edition]

      const customElem = this

      function dispatchEvent (name, data) {
        customElem.dispatchEvent(
          new MessageEvent(
            name,
            { data, composed: true }
          )
        )
      }

      const scriptPaddle = document.createElement("script")
      scriptPaddle.setAttribute("src",
        "https://cdn.paddle.com/paddle/paddle.js"
      )
      scriptPaddle.async = true
      scriptPaddle.onload = function () {
        customElem.Paddle = Paddle

        if (sandboxMode) {
          Paddle.Environment.set("sandbox")
        }

        // Necessary for calculating discounts
        Paddle.Product.Prices(
          customElem.subscriptionIds.monthly,
          1,
          result => {
            const data = {
              country: result.country,
              price: Object.assign({}, result.price),
            }
            dispatchEvent("monthlyPriceDataReceived", data)
          }
        )

        Paddle.Setup({
          vendor: sandboxMode ? 10938 : 165577,
          eventCallback: (eventObj) => {
            console.info(eventObj)
            if (
              eventObj.event == "Checkout.Loaded" ||
              eventObj.event == "Checkout.Login" ||
              eventObj.event == "Checkout.Vat.Applied" ||
              eventObj.event == "Checkout.Vat.Remove"
            ) {
              const prices = eventObj.eventData.checkout.prices.customer
              dispatchEvent("subtotalChanged",
                Number(prices.total) - Number(prices.total_tax)
              )
              dispatchEvent("vatChanged", Number(prices.total_tax))
              dispatchEvent("totalChanged", Number(prices.total))
              dispatchEvent("currencyChanged", prices.currency)
            }
            else if (
              eventObj.event == "Checkout.Error" ||
              eventObj.event == "Checkout.CountryChanged"
            ) {
              // New prices are not available yet
              dispatchEvent("subtotalChanged", null)
              dispatchEvent("vatChanged", null)
              dispatchEvent("totalChanged", null)
              dispatchEvent("currencyChanged", null)
            }
          }
        })

        customElem.openForProduct(customElem.subscriptionIds.yearly)
      }
      this.shadowRoot.append(scriptPaddle)
    }

    static get observedAttributes() {
      return ["pricing-frequency"]
    }

    attributeChangedCallback() {
      const freq = this.getAttribute("pricing-frequency")
      console.info("Frequency changed to " + freq)

      if (this.Paddle) {
        const productId =
          freq == "Month"
            ? this.subscriptionIds.monthly
            : freq == "Half-Year"
              ? this.subscriptionIds.halfYearly
              : this.subscriptionIds.yearly


        this.openForProduct(productId)
      }
    }
  }
)
